import '@babel/polyfill/noConflict';
import './vendor/modernizr';
import 'root-consent';
import objectFitImages from 'object-fit-images';

import { AnimateObserver } from './lib/animate-observer';
import { Modal } from './lib/modal';
import { Carousel } from './lib/carousel';
import { Sticky } from './lib/sticky';
import { Trigger } from './lib/trigger';
import { LazyLoad } from './lib/lazy-load';


objectFitImages();

const animate = new AnimateObserver();
animate.init();

const modal = new Modal();
modal.init();

const carousel = new Carousel();
carousel.init();

const sticky = new Sticky();
sticky.init();

const trigger = new Trigger();
trigger.init();

const lazy = new LazyLoad();
lazy.init();

const Consent = rootConsent( 'body', {
    messageText: 'This site uses cookies to help us manage and improve the website and to analyse how visitors use our site. By continuing to use the website, you are agreeing to our use of cookies. For further information about cookies, including about how to change your browser settings to no longer accept cookies, please view our <a href="/cookie-notice">Cookie Policy</a>.',
    approveLabel: 'OK',
    delay: 500,
    alwaysApproved: true
} );